import { Observable } from 'rxjs';
import { concatMap, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import isEmpty from 'lodash/isEmpty';
import { Actions } from '../../actions';
import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import * as userActionCreators from '../../user/action-creators';
import * as auth from '@webapp/sdk/auth';
import * as users from '@webapp/sdk/users';
import AppState from '../../state';

const successStatus = 'SUCCESS';

export const verifyAccountEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, actionCreators.VerifyAccount>(actions.VERIFY_ACCOUNT),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const user = await auth.getUser();

        if (!user) {
          await auth.confirm(action.data);

          if (state.auth.registrationData) {
            return [
              new actionCreators.LoginUser(state.auth.registrationData, true),
              new actionCreators.VerifyAccountSuccess(),
            ];
          }
        } else {
          const { notVerifiedEmail, notVerifiedPhone } =
            state?.user?.profile ?? {};
          let profileData: Record<string, string | null> = {};
          let userData: Record<string, string | null> = {
            'custom:verified': 'true',
          };

          if (notVerifiedEmail) {
            const verificationStatus = await auth.verifyEmailSubmit(
              action.data.code
            );

            if (verificationStatus === successStatus) {
              profileData = {
                notVerifiedEmail: null,
                email: notVerifiedEmail,
              };

              userData = {
                ...userData,
                email: notVerifiedEmail,
                'custom:valid_email': notVerifiedEmail,
              };
            }
          } else if (notVerifiedPhone) {
            const verificationStatus = await auth.verifyPhoneSubmit(
              action.data.code
            );

            if (verificationStatus === successStatus) {
              profileData = {
                notVerifiedPhone: null,
                telephone: notVerifiedPhone,
              };

              userData = {
                ...userData,
                phone_number: notVerifiedPhone,
                'custom:valid_phone': notVerifiedPhone,
              };
            }
          }

          if (!isEmpty(profileData)) {
            const [profile] = await Promise.all([
              users.updateProfile(profileData),
              auth.updateUser(user, userData),
            ]);

            return [
              new actionCreators.VerifyAccountSuccess(),
              new userActionCreators.UpdateUserSuccess(profile, true),
            ];
          }
        }

        return [new actionCreators.VerifyAccountSuccess()];
      } catch (err) {
        return [new actionCreators.VerifyAccountError(err.code)];
      }
    }),
    concatMap((actions) => actions)
  );
